
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";

import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { useHistory, useLocation } from 'react-router-dom';
import PrijavniObrazec from "./PrijavniObrazec";
import BiCheckBox from '../../uic/controls/BiCheckBox';
import BiTextArea from '../../uic/controls/BiTextArea';


import BiFormTable from '../../uic/formTable/BiFormTable';
import BiFormRow from '../../uic/formTable/BiFormRow';
import BiFormCell from '../../uic/formTable/BiFormCell';
import BiFormSection from '../../uic/formTable/BiFormSection';
import BiCheckBoxList from "../../uic/controls/BiCheckBoxList";
import { httpGet, httpPost, httpFileDownload } from "../../helpers/httpHelper";

import authService from '../../api-authorization/AuthorizeService'
import { useNavigate } from "../../../../node_modules/react-router/index";
import StatusObrazca from "./StatusObrazca";
import BiFileUpload from "../../uic/controls/BiFileUpload";
import KultureObrazec from "./KultureObrazec";
import SemenskiMaterialObrazec from "./SemenskiMaterialObrazec";
import IzpisiObrazca from "./IzpisiObrazca";
import yesno from 'yesno-dialog'

const UrejanjeObrazcaStranka = () => {
    const navigate = useNavigate();

    const { sessionReady, sessionData, setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)
    const { data, setUrl: setObrazciURL, setData, isLoaded } = useFetch(null);

    const [tipPogleda, setTipPogleda] = useState(1);

    const location = useLocation();


  
    
    

    useEffect(() => {
        if (sessionReady) {
            //setLoading(true);
            setObrazciURL('api/obrazci/GetObrazec?pIdObrazca=' + location.state.pIdObrazca);

            

        }
    }, [sessionReady])


    const onObrazecChanged = (e) => {
        const { name, value } = e.target;
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: value,
                changed: true
            }
        }));
    }

    const onObrazecTableChange = (e, name, mainKey, item1) => {

        console.log("changed", e, name, mainKey, item1);
        const { value } = e.target;


        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].map(ch =>
                    ch[mainKey] === item1[mainKey] ? { ...ch, [e.target.name]: e.target.value, changed: true } : ch
                ),
                changedChildren: true,
                changed: true
            }
        }));
    }
    const onObrazecTableAdd = (name, mainKey, item) => {


        console.log(name, mainKey, item);
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].concat(item),
                changed: true
            }
        }));
    }

    const onObrazecTableRemove = (name, mainKey, item) => {


        console.log(name, mainKey, item)
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].filter(pr => pr[mainKey] != item[mainKey]),
                changed: true
            }
        }));
    }

    const onObrazecCBListChanged = (checked, name, items, item) => {

        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: items.map(ch =>
                    ch.id === item.id ? { ...ch, izbran: checked } : ch
                ),
                changedChildren: true,
                changed: true
            }
        }));
    }

    const onObrazecDatotekaAdd = (datoteka, name) => {
        console.log(datoteka);
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].concat(datoteka),
                changed: true
            }
        }));
    }

    const onObrazecDatotekaRemove = (PIdDatoteke, name) => {
        console.log(PIdDatoteke)
        setData(prevState => ({
            ...prevState,
            obrazecDetail: {
                ...prevState.obrazecDetail,
                [name]: prevState.obrazecDetail[name].filter(pr => pr.pIdDatoteke != PIdDatoteke),
                changed: true
            }
        }));
    }

    const onObrazecMainDatotekaAdd = (datoteka, name) => {
        console.log(datoteka);
        setData(prevState => ({
            ...prevState,
            obrazec: {
                ...prevState.obrazec,
                [name]: prevState.obrazec[name].concat(datoteka),
                changed: true
            }
        }));
    }

    const onObrazecMainDatotekaRemove = (PIdDatoteke, name) => {
        console.log(PIdDatoteke)
        setData(prevState => ({
            ...prevState,
            obrazec: {
                ...prevState.obrazec,
                [name]: prevState.obrazec[name].filter(pr => pr.pIdDatoteke != PIdDatoteke),
                changed: true
            }
        }));
    }

    const onObrazecMainChanged = (e) => {
        const { name, value } = e.target;
        setData(prevState => ({
            ...prevState,
            obrazec: {
                ...prevState.obrazec,
                [name]: value,
                changed: true
            }
        }));
    }

 

    const shraniObrazec = () => {
        

        setLoading(true);
        console.log(data);
        httpPost(
            "api/obrazci/setObrazec",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail) }
                )
            },
            (ret) => {
                if (ret.success) {

                } else {
                    toastError(ret.message);
                }
                setLoading(false);


            },
            authService);
    }

    const potrdiObrazec = (po) => {

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/potrdiObrazec",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const potrdiObrazecPisarni = (po) => {

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/potrdiObrazecPisarni",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const potrdiObrazecPosta = (po) => {

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/potrdiObrazecPosta",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const potrdiObrazecZakljuci = (po) => {

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/potrdiObrazecZakljuci",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const potrdiObrazecPodpis = (po) => {

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/potrdiObrazecPodpis",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const potrdiObrazecOdstop =  (po) => {


        if (data.obrazecDetail.datumOdstopa == null) {
            alert("Vpišite datum odstopa!");
            return;
        }

        setLoading(true);
        console.log(data);

        //const yes = await yesno({
        //    labelYes: "Da",
        //    labelNo: "Ne",
        //    bodyText: "Ali želite zaključiti shemo?"
        //})

        //if (yes == true) {
            httpPost(
                "api/obrazci/potrdiObrazecOdstop",
                {
                    body: JSON.stringify(
                        { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                    )
                },
                (ret) => {
                    if (ret.success) {


                        setTipPogleda(1);
                        navigate('/obrazciAdmin', { replace: true });

                        toastOK("Uspešno!");

                    } else {
                        toastError(ret.message);
                    }
                    setLoading(false);
                },
                authService);
        /*}*/

        setLoading(false);
    }


    const potrdiObrazecBrisi = async  (po) => {

        setLoading(true);
        console.log(data);

        const yes = await yesno({
            labelYes: "Da",
            labelNo: "Ne",
            bodyText: "Ali želite izbrisati obrazec?"
        })

        if (yes == true) {
        httpPost(
            "api/obrazci/potrdiObrazecBrisi",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail), potrdi: po }
                )
            },
            (ret) => {
                if (ret.success) {


                    setTipPogleda(1);
                    navigate('/obrazciAdmin', { replace: true });

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);
        }

        setLoading(false);
    }

    const posljiObrazec = (po) => {

        console.log(data.obrazec, data.obrazecDetail);

        if (data.obrazec.pIdTipObrazca == 1) {
            if (data.obrazecDetail.podpisnik == null || data.obrazecDetail.podpisnik.length == 0) {
                alert("Polje podpisnik je obvezno!");
                return;
            }
        }

        if (data.obrazec.pIdTipObrazca == 3) {

            if (data.obrazecDetail.podpisnik == null || data.obrazecDetail.podpisnik.length == 0) {
                alert("Polje podpisnik je obvezno!");
                return;
            }

            //dobimo id-je vrstic z napakami
            var idji = [];
            data.obrazecDetail.kolicine.forEach(o => {

                if (o.sifRazlogDokupa.id == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }

                if (o.sifVrsta.id == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }

                if (o.sifSorta.id == null && o.sorta == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }

                if (o.kolicina == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }

                if (o.sifEnoraMere.id == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }

                if (o.datumSetve == null) {
                    idji.push(o.pIdSemenskiMaterialObrazecKolicine);
                }


            });

            if (idji.length > 0) {
                //na koncu se setirajo vse vrstice z napakami
                setData(prevState => ({
                    ...prevState,
                    obrazecDetail: {
                        ...prevState.obrazecDetail,
                        kolicine: prevState.obrazecDetail.kolicine.map(ch =>
                            idji.indexOf(ch.pIdSemenskiMaterialObrazecKolicine) > -1 ? { ...ch, napakaPriVnosu: true } : { ...ch, napakaPriVnosu: false }
                        ),
                        changedChildren: true,
                        changed: true
                    }
                }));

                alert("Izpolnite vsa polja v označenih rdečih vrsticah. ");
                return;
            }

            var CItems = data.obrazecDetail.kolicine.filter(o => o.sifRazlogDokupa.naziv == "C");
            if (CItems.length > 0 && (data.obrazecDetail.cOpomba ==null || data.obrazecDetail.cOpomba.length == 0)) {
                alert("Sorta ni registrirana v podatkovni zbirki MKGP. Obvezno navedite razlog v *Razlog dokupa.");
                return;
            }
        }


       

        setLoading(true);
        console.log(data);

        httpPost(
            "api/obrazci/posljiObrazec",
            {
                body: JSON.stringify(
                    { json: JSON.stringify(data.obrazec), jsonDetail: JSON.stringify(data.obrazecDetail) }
                )
            },
            (ret) => {
                if (ret.success) {

                    if (sessionData.admin) {
                        setTipPogleda(1);
                        navigate('/obrazciAdmin', { replace: true });
                    } else {
                        navigate('/obrazciStranka', { replace: true });
                    }

                    toastOK("Uspešno!");

                } else {
                    toastError(ret.message);
                }
                setLoading(false);
            },
            authService);

    }

    const disabled = () => {

        if (data.obrazec != null) {

            if (sessionData.user.admin == true) {
                if (data.obrazec.pIdStatus < 13) {
                    return false;
                }
            }

            if (data.obrazec.pIdStatus >= 3) {
                return true;
            }

            if (sessionData.user.admin != true) {
                if (data.obrazec.pIdStatus == 3) {
                    return true;
                }
            }
        }
        return false;
    }

    const disabledadmin = () => {

        if (data.obrazec != null) {

            if (data.obrazec.pIdStatus >= 4) {
                return true;
            }

            if (sessionData.user.admin != true) {
                if (data.obrazec.pIdStatus == 3) {
                    return true;
                }
            }
        }
        return false;
    }
    return (

        <Fragment >

            {data &&
                <Fragment >
                    {tipPogleda == 1 &&
                        <Fragment >
                            <div >

                                <div className="form-inline" style={{ margin: "5px 0px" }}>
                                    <BiButton disabled={disabled()} className="btn-outline-secondary" margin="4px" icon="fas fa-save" onClick={shraniObrazec} >Shrani</BiButton>
                                    {sessionData.user.admin && data.obrazec.pIdTipObrazca != 3 &&
                                        <Fragment>
                                            <BiButton className="btn-danger" margin="4px" icon="fa-solid fa-outdent" onClick={() => potrdiObrazecOdstop(true)} >Odstop</BiButton>
                                            <BiButton className="btn-warning" margin="4px" icon="fa-solid fa-ban" onClick={() => potrdiObrazecBrisi(true)} >Briši</BiButton>
                                        </Fragment>
                                    }

                                    {sessionData.user.admin &&
                                        <IzpisiObrazca
                                            obrazec={data.obrazec}
                                            obrazecDetail={data.obrazecDetail}
                                        >
                                        </IzpisiObrazca>
                                    }
                                    {sessionData.user.admin &&
                                        <Fragment>
                                            {data.obrazec != null && data.obrazec.pIdStatus < 3 &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-success" margin="4px" icon="fa-solid fa-building-circle-check" onClick={() => potrdiObrazecPisarni(true)} >V pisarni</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && (data.obrazec.pIdStatus < 3 || data.obrazec.pIdStatus > 3) && (data.obrazec.pIdTipObrazca != 4 && data.obrazec.pIdTipObrazca != 5 && data.obrazec.pIdTipObrazca != 6) &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-warning" margin="4px" icon="fa-solid fa-dumpster" onClick={() => potrdiObrazecPosta(true)} >Vrnjen po pošti</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && data.obrazec.pIdStatus < 4 && data.obrazec.pIdStatus > 2 && data.obrazec.pIdTipObrazca == 1 &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-danger" margin="4px" icon="fas fa-circle-xmark" onClick={() => setTipPogleda(2)} >Zavrni obrazec</BiButton>
                                                    <BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => potrdiObrazec(true)} >Potrdi obrazec</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && data.obrazec.pIdStatus < 4 && data.obrazec.pIdStatus > 2 && (data.obrazec.pIdTipObrazca == 5 || data.obrazec.pIdTipObrazca == 6) &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-danger" margin="4px" icon="fas fa-circle-xmark" onClick={() => setTipPogleda(2)} >Zavrni obrazec</BiButton>
                                                    <BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => potrdiObrazec(true)} >Potrdi obrazec</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && data.obrazec.pIdStatus < 4 && data.obrazec.pIdStatus > 2 && (data.obrazec.pIdTipObrazca != 1 && data.obrazec.pIdTipObrazca != 5 && data.obrazec.pIdTipObrazca != 6) &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => potrdiObrazec(true)} >Potrdi obrazec</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && (data.obrazec.pIdStatus == 4 || data.obrazec.pIdStatus == 5) && (data.obrazec.pIdTipObrazca == 4 || data.obrazec.pIdTipObrazca == 5 || data.obrazec.pIdTipObrazca == 6) &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-warning" margin="4px" icon="fas fa-check" onClick={() => potrdiObrazecPodpis(true)} >V podpis</BiButton>
                                                </div>
                                            }
                                            {data.obrazec != null && data.obrazec.pIdStatus == 9 && (data.obrazec.pIdTipObrazca == 4 || data.obrazec.pIdTipObrazca == 5 || data.obrazec.pIdTipObrazca == 6) &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-danger" margin="4px" icon="fas fa-check" onClick={() => potrdiObrazecZakljuci(true)} >Zaključi</BiButton>
                                                </div>
                                            }
                                        </Fragment>
                                    }

                                    {!sessionData.user.admin &&
                                        <Fragment>
                                            {data.obrazec.pIdStatus < 3 &&
                                                <div style={{ float: "right" }} >
                                                    <BiButton className="btn-success" margin="4px" icon="fas fa-check" onClick={() => posljiObrazec()} >Podpiši in pošlji</BiButton>
                                                </div>
                                            }
                                        </Fragment>
                                    }

                                </div>
                            </div>


                            <div style={{ marginBottom: "10px" }} >

                                {data.obrazec.pIdTipObrazca == 1 &&
                                    <b>Prijavni obrazec EKO</b>
                                }
                                {data.obrazec.pIdTipObrazca == 7 &&
                                    <b>Prijavni obrazec EPR</b>
                                }
                                {data.obrazec.pIdTipObrazca == 2 &&
                                    <b>Količine - obrazec</b>
                                }
                                {data.obrazec.pIdTipObrazca == 3 &&
                                    <b>Prošnja za neekološki razmnoževalni material</b>
                                }
                                {data.obrazec.pIdTipObrazca == 4 &&
                                    <b>Prijavni obrazec IP</b>
                                }

                                {data.obrazec.pIdTipObrazca == 5 &&
                                    <b>Prijavni obrazec ZPŽ</b>
                                }

                                {data.obrazec.pIdTipObrazca == 6 &&
                                    <b>Prijavni obrazec IK</b>
                                }

                                <span className="statusBadge" >
                                    {data.obrazec &&
                                        <StatusObrazca status={data.obrazec.pIdStatus}></StatusObrazca>
                                    }
                                </span>


                            </div>

                            {(data.obrazec.pIdTipObrazca == 1 || data.obrazec.pIdTipObrazca == 7 ||data.obrazec.pIdTipObrazca == 4 || data.obrazec.pIdTipObrazca == 5 || data.obrazec.pIdTipObrazca == 6) &&

                                <PrijavniObrazec
                                    admin={sessionData.user.admin}
                                    disabled={disabled()}
                                    obrazec={data.obrazecDetail}
                                    idObrazca={data.obrazec.idObrazca}
                                    onObrazecChanged={onObrazecChanged}
                                    onObrazecCBListChanged={onObrazecCBListChanged}
                                    onObrazecTableChange={onObrazecTableChange}
                                    onObrazecDatotekeAdd={onObrazecDatotekaAdd}
                                    onObrazecDatotekeRemove={onObrazecDatotekaRemove}
                                ></PrijavniObrazec>
                            }

                            {data.obrazec.pIdTipObrazca == 2 &&

                                <KultureObrazec
                                    admin={sessionData.user.admin}
                                    disabled={disabled()}
                                    obrazec={data.obrazecDetail}
                                    idObrazca={data.obrazec.idObrazca}
                                    onObrazecChanged={onObrazecChanged}
                                    onObrazecCBListChanged={onObrazecCBListChanged}
                                    onObrazecTableChange={onObrazecTableChange}
                                    onObrazecDatotekeAdd={onObrazecDatotekaAdd}
                                    onObrazecDatotekeRemove={onObrazecDatotekaRemove}
                                ></KultureObrazec>
                            }
                            {data.obrazec.pIdTipObrazca == 3 &&

                                <SemenskiMaterialObrazec
                                    admin={sessionData.user.admin}
                                    disabled={disabled()}
                                    obrazec={data.obrazecDetail}
                                    idObrazca={data.obrazec.idObrazca}
                                    idStatus={data.obrazec.pIdStatus}
                                    onObrazecChanged={onObrazecChanged}
                                    onObrazecCBListChanged={onObrazecCBListChanged}
                                    onObrazecTableChange={onObrazecTableChange}
                                    onObrazecDatotekeAdd={onObrazecDatotekaAdd}
                                    onObrazecDatotekeRemove={onObrazecDatotekaRemove}
                                    onObrazecTableAdd={onObrazecTableAdd}
                                    onObrazecTableRemove={onObrazecTableRemove}

                                ></SemenskiMaterialObrazec>
                            }

                            
                                
                           
                            


                        </Fragment>
                    }

                 

                    {((tipPogleda == 2 || data.obrazec.pIdStatus >= 4) && (data.obrazec.pIdTipObrazca == 1 || data.obrazec.pIdTipObrazca == 7 ||data.obrazec.pIdTipObrazca == 5 || data.obrazec.pIdTipObrazca == 6)) &&
                        <Fragment >
                            <div >

                                <div className="form-inline" style={{ margin: "5px 0px" }}>

                                    {sessionData.user.admin &&
                                        <Fragment>

                                            <div style={{ float: "right" }} >
                                                <BiButton disabled={disabledadmin()} className="btn-danger" margin="4px" icon="fas fa-circle-xmark" onClick={() => potrdiObrazec(false)} >Zavrni obrazec</BiButton>
                                            </div>
                                        </Fragment>
                                    }

                                </div>


                                <form className="form-inline">

                                    <BiFormTable columns={[
                                        { width: "380px" },
                                        { width: "40%" },
                                        { width: "60%" },
                                    ]}>
                                        <BiFormSection show={true} colSpan="3" label="Opomba" icon="fas fa-calendar-plus">
                                            <BiFormRow divider={true}></BiFormRow>

                                            <BiFormRow>
                                                <BiFormCell><BiLabel icon="fa-solid fa-hashtag">Razlog zavrnitve:</BiLabel></BiFormCell>
                                                <BiFormCell colSpan="2">
                                                    <BiTextArea disabled={disabledadmin()} name="opombaZavrnitve" value={data.obrazec.opombaZavrnitve} onChange={onObrazecMainChanged} rows="6" ></BiTextArea>
                                                </BiFormCell>
                                            </BiFormRow>
                                            <BiFormRow divider={true}></BiFormRow>
                                        </BiFormSection>


                                        <BiFormSection show={true} colSpan="3" label="Dopolnite" icon="fas fa-sort-amount-up-alt">
                                            <BiFormRow divider={true}></BiFormRow>
                                            <BiFormRow>

                                                <BiFormCell colSpan="3">

                                                    <BiCheckBoxList disabled={disabledadmin()} name="dopolnitveIzbira" items={data.obrazecDetail.dopolnitveIzbira} onChange={onObrazecCBListChanged}></BiCheckBoxList>

                                                </BiFormCell>
                                            </BiFormRow>
                                            <BiFormRow divider={true}></BiFormRow>
                                            <BiFormRow divider={true}></BiFormRow>
                                            <BiFormRow divider={true}></BiFormRow>
                                        </BiFormSection>

                                        {/*<BiFormSection show={true} colSpan="3" label="Datoteke" icon="fas fa-file">*/}
                                        {/*    <BiFormRow divider={true}></BiFormRow>*/}
                                        {/*    <BiFormRow>*/}
                                        {/*        <BiFormCell colSpan="3">*/}
                                        {/*            <div >*/}
                                        {/*                <BiFileUpload name="datoteke" readOnly={data.obrazec.pIdStatus >= 4} idObrazca={data.obrazec.idObrazca} tipDatoteke={1} items={data.obrazecDetail.datoteke} onAdd={onObrazecDatotekaAdd} onRemove={onObrazecDatotekaRemove}></BiFileUpload>*/}
                                        {/*            </div>*/}
                                        {/*        </BiFormCell>*/}
                                        {/*    </BiFormRow>*/}
                                        {/*</BiFormSection>*/}

                                    </BiFormTable>
                                </form>

                            </div>


                        </Fragment>
                    }

                    {/*{(tipPogleda == 1 && data.obrazec.pIdTipObrazca == 1) && */}
                    {/*    <Fragment >*/}
                    {/*        <div >*/}

                    {/*            <div className="form-inline" style={{ margin: "5px 0px" }}>*/}

                    {/*                {sessionData.user.admin &&*/}
                    {/*                    <Fragment>*/}

                    {/*                        <div style={{ float: "right" }} >*/}
                    {/*                            <BiButton disabled={disabled()} className="btn-danger" margin="4px" icon="fas fa-circle-xmark" onClick={() => potrdiObrazec(false)} >Zavrni obrazec</BiButton>*/}
                    {/*                        </div>*/}
                    {/*                    </Fragment>*/}
                    {/*                }*/}

                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </Fragment>*/}
                    {/*}*/}


                    <form className="form-inline">

                        <BiFormTable columns={[
                            { width: "100%" }
                        ]}>

                            <BiFormSection show={true} label="Datoteke (vse)" icon="fas fa-file">
                                <BiFormRow divider={true}></BiFormRow>
                                {data.obrazec.pIdTipObrazca == 5 &&
                                    <fragment>
                                    <BiFormRow responsive={true} >
                                        <BiFormCell responsive={true} col="col-lg-16">
                                            <BiLabel><b>Za dodajanje datoteke izberite tip datoteke:</b></BiLabel><br/>
                                                <BiLabel>(potrjena specifikacija) - potrjena specifikacija za zaščiten kmetijski pridelek oziroma živilo (veljavna, s strani pristojnega ministrstva potrjena specifikacija)</BiLabel>
                                                <BiLabel>(plani in postopki) - plani in postopki notranjih kontrol, kadar je stranka skupina proizvajalcev</BiLabel>
                                                <BiLabel>(seznam proizvajalcev) - seznam proizvajalcev, ki so člani in so  vključeni v postopek certificiranja, kadar je stranka skupina proizvajalcev</BiLabel>
                                        </BiFormCell>
                                    </BiFormRow>
                                        <BiFormRow divider={true}></BiFormRow>
                                    </fragment>
                                }
                                {data.obrazec.pIdTipObrazca == 6 &&
                                    <fragment>
                                        <BiFormRow responsive={true} >
                                            <BiFormCell responsive={true} col="col-lg-16">
                                                <BiLabel><b>Za dodajanje datoteke izberite tip datoteke:</b></BiLabel><br />
                                                <BiLabel>(seznam kmetijskih pridelkov) - seznam kmetijskih pridelkov ali živil z označbo izbrana kakovost</BiLabel>
                                                <BiLabel>(seznam vseh subjektov) - seznam vseh subjektov vključenih v postopek certificiranja, kadar je stranka skupina</BiLabel>
                                            </BiFormCell>
                                        </BiFormRow>
                                        <BiFormRow divider={true}></BiFormRow>
                                    </fragment>
                                }
                                <BiFormRow>
                                    <BiFormCell colSpan="3">
                                        <div style={{minHeight:"100px"}} >
                                            <BiFileUpload name="datoteke" readOnly={!(sessionData.user.admin || data.obrazec.pIdStatus < 3)} items={data.obrazec.datoteke} idObrazca={data.obrazec.pIdObrazca} tipiDatoteke={data.obrazec.tipiDatoteke} onAdd={onObrazecMainDatotekaAdd} onRemove={onObrazecMainDatotekaRemove}></BiFileUpload>
                                        </div>
                                    </BiFormCell>
                                </BiFormRow>
                                <BiFormRow divider={true}></BiFormRow>
                                <BiFormRow divider={true}></BiFormRow>
                            </BiFormSection>

                        </BiFormTable>
                    </form>

                </Fragment>
            }
        </Fragment>
    );

}

export default UrejanjeObrazcaStranka;